export enum TextSizes {
    PAGE_TITLE = '5.5vh',
    SUBHEADER = '3.3vh',
    DESCRIPTION = '2.7vh',
    SMALL_DESCRIPTION = '2vh',
}